import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadFlamingo'

const Download: React.FunctionComponent = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'UX/UI モダナイゼーション SaaS 業務システム 変換サービス システム改修'}
        image={'https://aitria.co.jp/images/img/download/flamingo/ogp.png'}
        url={'https://aitria.co.jp/download/flamingo/'}
        title="UX/UIモダナイゼーションSaaS「flamingo」 | 資料ダウンロード | Aitria（アイトリア）"
        description="システム改修なしでUX/UIを改善する「flamingo」の概要や機能、導入事例、料金について紹介した資料です。"
      />
      <Template />
    </>
  )
}

export default Download
